<rt-dropdown
  [width]="DropdownWidth.LargeXXXX"
  (click)="preventNonAnchorEventBubbling($event)"
  class="headers"
>
  <div class="headers">
    <rt-dropdown-header [fullWidthTitle]="true" class="first-column column">
      {{ 'app.new_search_page.boolean_search_info.fields_heading' | translate }}
    </rt-dropdown-header>

    <rt-dropdown-header [fullWidthTitle]="true" class="column">
      {{ 'app.new_search_page.boolean_search_info.operators_heading' | translate }}
    </rt-dropdown-header>
  </div>
  <div class="body" (click)="$event.preventDefault()">
    <div class="fields first-column" padding-tb-small-x padding-lr-small>
      <div class="fields__content">
        @for (field of fields; track trackByIndex($index)) {
          <div class="field fields__item">
            <rt-icon [name]="field.icon" />
            <span>{{ field.label }}</span>
          </div>
        }
      </div>
    </div>
    <div class="operators" padding-tb-small-x padding-lr-small>
      <div class="operators__content">
        @for (operator of operators; track trackByIndex($index)) {
          <div class="operators__item">
            <div class="operators__item--syntax" [innerHtml]="operator.label"></div>
            <p>{{ operator.description }}</p>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="footer">
    <rt-dropdown-item [href]="readMoreLink | translate" hrefTarget="_blank">
      <rt-icon prefix name="book-open-page-variant" />
      {{ 'app.common.read_more_in_help' | translate }}
    </rt-dropdown-item>
  </div>
</rt-dropdown>
